// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared agent avatar chip used both at a node's bottom edge (NodeAgentBadges)
   and in the canvas dock (AgentDock) so canvas and node agents look identical
   (per the concept). A white rounded chip with a category-tinted robot; a
   hover ✕ detaches. */
.gGY0IVODLwUm1usIPB0M {
  position: relative;
}

.rfZsyDztfM6bIy8tbnZw {
  position: relative; /* dev/115: anchors the running dot */
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: var(--curio-card-bg);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  color: var(--curio-role-running-fg); /* overridden by a category tint class */
  padding: 0;
}

/* Selected agent: the app's standard blue focus border (same treatment used on
   selected package cards / headers), so the clicked agent is clearly highlighted. */
.u6UrTzV7ynuZ9zZckGGM .rfZsyDztfM6bIy8tbnZw {
  border-color: var(--curio-accent-sky-fg, var(--curio-role-running-fg));
  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));
  outline-offset: 1px;
}

.R8ySgYw4zhj4h_7IvnTv {
  font-size: 16px;
  color: inherit;
}

.xh63S5I6mC_xtbc8pPP6 {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  font-size: 10px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.12s ease;
}

.gGY0IVODLwUm1usIPB0M:hover .xh63S5I6mC_xtbc8pPP6,
.gGY0IVODLwUm1usIPB0M:focus-within .xh63S5I6mC_xtbc8pPP6 {
  opacity: 1;
}

/* dev/115 — background job running: a pulsing dot on the chip's corner. */
.SCGR5i63US2et732RsLW {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--curio-role-running-fg);
  box-shadow: 0 0 0 2px var(--curio-card-bg);
  animation: hte8A0Wa2Rv0g12o40zG 1.4s ease-in-out infinite;
}

@keyframes hte8A0Wa2Rv0g12o40zG {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

@media (prefers-reduced-motion: reduce) {
  .SCGR5i63US2et732RsLW { animation: none; }
}

/* Category tints (icon color; the chip stays white). */
.Wl2SJg9IW6tQK4uHSwhx     { color: var(--curio-category-agent-node-fg); }
.mcN9nTuV_16ozui11CFl   { color: var(--curio-category-agent-canvas-fg); }
.t0kzngTIEV7LfiaTfdAA     { color: var(--curio-category-agent-data-fg); }
.AQi19O16jfzXr84D9AP5 { color: var(--curio-category-agent-evaluate-fg); }
.eKf0cPJnucXr4_XeCNSB  { color: var(--curio-category-agent-package-fg); }
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/AgentAvatarBadge.module.css"],"names":[],"mappings":"AAAA;;;sBAGsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,qCAAqC;EACzD,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;EACf,mCAAmC,EAAE,wCAAwC;EAC7E,UAAU;AACZ;;AAEA;oFACoF;AACpF;EACE,sEAAsE;EACtE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,yDAAsD;AACxD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,wBAAc,eAAe,EAAE;AACjC;;AAEA,uDAAuD;AACvD,4BAAiB,0CAA0C,EAAE;AAC7D,0BAAiB,4CAA4C,EAAE;AAC/D,4BAAiB,0CAA0C,EAAE;AAC7D,wBAAiB,8CAA8C,EAAE;AACjE,yBAAiB,6CAA6C,EAAE","sourcesContent":["/* Shared agent avatar chip used both at a node's bottom edge (NodeAgentBadges)\n   and in the canvas dock (AgentDock) so canvas and node agents look identical\n   (per the concept). A white rounded chip with a category-tinted robot; a\n   hover ✕ detaches. */\n.badge {\n  position: relative;\n}\n\n.avatar {\n  position: relative; /* dev/115: anchors the running dot */\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  background: var(--curio-card-bg);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);\n  cursor: pointer;\n  color: var(--curio-role-running-fg); /* overridden by a category tint class */\n  padding: 0;\n}\n\n/* Selected agent: the app's standard blue focus border (same treatment used on\n   selected package cards / headers), so the clicked agent is clearly highlighted. */\n.badgeActive .avatar {\n  border-color: var(--curio-accent-sky-fg, var(--curio-role-running-fg));\n  outline: 2px solid var(--curio-accent-sky-fg, var(--curio-focus-ring));\n  outline-offset: 1px;\n}\n\n.icon {\n  font-size: 16px;\n  color: inherit;\n}\n\n.detach {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: none;\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  font-size: 10px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.12s ease;\n}\n\n.badge:hover .detach,\n.badge:focus-within .detach {\n  opacity: 1;\n}\n\n/* dev/115 — background job running: a pulsing dot on the chip's corner. */\n.runningDot {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--curio-role-running-fg);\n  box-shadow: 0 0 0 2px var(--curio-card-bg);\n  animation: agentRunningPulse 1.4s ease-in-out infinite;\n}\n\n@keyframes agentRunningPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.35; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .runningDot { animation: none; }\n}\n\n/* Category tints (icon color; the chip stays white). */\n.tint_node     { color: var(--curio-category-agent-node-fg); }\n.tint_canvas   { color: var(--curio-category-agent-canvas-fg); }\n.tint_data     { color: var(--curio-category-agent-data-fg); }\n.tint_evaluate { color: var(--curio-category-agent-evaluate-fg); }\n.tint_package  { color: var(--curio-category-agent-package-fg); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `gGY0IVODLwUm1usIPB0M`,
	"avatar": `rfZsyDztfM6bIy8tbnZw`,
	"badgeActive": `u6UrTzV7ynuZ9zZckGGM`,
	"icon": `R8ySgYw4zhj4h_7IvnTv`,
	"detach": `xh63S5I6mC_xtbc8pPP6`,
	"runningDot": `SCGR5i63US2et732RsLW`,
	"agentRunningPulse": `hte8A0Wa2Rv0g12o40zG`,
	"tint_node": `Wl2SJg9IW6tQK4uHSwhx`,
	"tint_canvas": `mcN9nTuV_16ozui11CFl`,
	"tint_data": `t0kzngTIEV7LfiaTfdAA`,
	"tint_evaluate": `AQi19O16jfzXr84D9AP5`,
	"tint_package": `eKf0cPJnucXr4_XeCNSB`
};
export default ___CSS_LOADER_EXPORT___;
